import { Button } from "../../atoms/button/Button";
import { Container } from "../../atoms/container/Container";
import { IncreaseRadius } from "../increaseRadius/IncreaseRadius";
import { NearByHospital } from "../nearbyHospital/NearByHospital";
import style from "../../../pages/logistics/logistics.module.scss";
import { PickupLocation } from "../pickupLocation/PickupLocation";
import { SelectedAddressComponent } from "../../molecules/selectedAddress/SelectedAdddress";
import PreferredHospital from "../preferredHospital/PreferredHospital";
import { BackgroundWrapper } from "../../atoms/backgroundWrapper/BackgroundWrapper";
import { Text } from "../../atoms/text/Text";
import { CustomDropLocation } from "../customDropLocation/customDropLocation";
import { FaChevronDown, FaChevronUp } from "react-icons/fa"
import pickupStyles from "../pickupLocation/pickupLocation.module.scss";
import { UseGetStoreData } from "../../../hooks/getStoreData/UseGetStoreData";


interface LogisticsAddressTabProps {
  isAddressSelected: boolean;
  selectedAddress: any;
  setSelectedAddress: any;
  handleAddressSelection: any;
  handleEditSelectedAddress: any;
  isHospitalSelected: boolean;
  selectedHospital: any;
  handleEditHospital: any;
  renderHospitalUi: boolean;
  value: any;
  handleIncreaseRadius: any;
  marks: any;
  patientAddress: any;
  hospitalLists: any;
  handleSelectHospital: any;
  handleStartEmergency: any;
  component?: string;
  officePreferred: any,
  isCustomDropLocationEnabled?: boolean;
  setIsCustomDropLocationEnabled?: (value: boolean) => void;
  fromPage?: string;
}

export const LogisticsAddressTab: React.FC<LogisticsAddressTabProps> = ({
  isAddressSelected,
  selectedAddress,
  setSelectedAddress,
  handleAddressSelection,
  handleEditSelectedAddress,
  isHospitalSelected,
  selectedHospital,
  handleEditHospital,
  renderHospitalUi,
  value,
  handleIncreaseRadius,
  marks,
  patientAddress,
  hospitalLists,
  handleSelectHospital,
  handleStartEmergency,
  component,
  officePreferred,
  isCustomDropLocationEnabled,
  setIsCustomDropLocationEnabled = () => { },
  fromPage,
}) => {
  //console.log(patientAddress, "patientAddress");
  const { getTicketData} = UseGetStoreData();
  const isEmergency = getTicketData?.currentMedicalStatusResponse?.isItEmergency.toLowerCase();
  

  return (
    <Container className={style.logistics_box}>
      {!isAddressSelected ? (
        <Container className={style.logistics_container}>
          <PickupLocation
            selectedAddress={selectedAddress}
            setSelectedAddress={setSelectedAddress}
            handleAddressSelection={handleAddressSelection}
          />
        </Container>
      ) : (
        ""
      )}

      {isAddressSelected ? (
        <Container className={style.logistics_container}>
          <div >
            <SelectedAddressComponent
              addressIcon="/images/home.png"
              addressBadge="saved"
              title={"Selected Pickup Location"}
              addressSelected={selectedAddress}
              renderSelectedAddressUi={handleEditSelectedAddress}
              showEditButton={!fromPage?.includes("Drop Location")}
            />
          </div>

        </Container>
      ) : (
        ""
      )}
      {(isAddressSelected && renderHospitalUi) && <div style={{ minWidth: "49%", height: "100%" }}>
        <PreferredHospital
          pickupLocation={patientAddress}
          nearByHospital={selectedAddress?.preferredHospital || []}
          handleAddressSelection={handleSelectHospital}
          selectedHospital={selectedHospital}
          component={component}
          headerName={"Preferred Hospital"}
        />
      </div>}
      {isAddressSelected && renderHospitalUi && officePreferred?.length > 0 && (
        officePreferred.map((elem: any) => (
          <div style={{ minWidth: "49%", height: "100%" }}>
            <PreferredHospital
              pickupLocation={patientAddress}
              nearByHospital={[elem]}
              handleAddressSelection={handleSelectHospital}
              selectedHospital={selectedHospital}
              component={component}
              headerName="Premises Preferred Hospital"
            />
          </div>
        ))
      )}


      {
        isAddressSelected && renderHospitalUi &&
        <BackgroundWrapper className={style.background}>
          <Container className={style.flex_wrapper}>
            <Text text={"Select Custom Drop Location"} className={pickupStyles.title} />
            <button
              onClick={() => setIsCustomDropLocationEnabled(!isCustomDropLocationEnabled)}
              className={pickupStyles.title}
            >
              {isCustomDropLocationEnabled ? <FaChevronUp /> : <FaChevronDown />}
            </button>
          </Container>
          {
            isAddressSelected && isCustomDropLocationEnabled && renderHospitalUi &&
            <Container className={style.logistics_container}>
              <CustomDropLocation
                pickupLocation={patientAddress}
                handleAddressSelection={handleSelectHospital}
              />
            </Container>
          }
        </BackgroundWrapper>
      }


      {isAddressSelected && isHospitalSelected ? (
        <Container className={style.logistics_container}>
          <SelectedAddressComponent
            addressIcon="/images/hospital.png"
            addressBadge="Preferred"
            title={"Selected Drop Location"}
            addressSelected={selectedHospital}
            renderSelectedAddressUi={handleEditHospital}
          />
        </Container>
      ) : (
        <></>
      )}
      {renderHospitalUi ? (
        <Container>
          <IncreaseRadius
            value={value}
            handleIncreaseRadius={handleIncreaseRadius}
            marks={marks}
          />
        </Container>
      ) : (
        ""
      )}
      {renderHospitalUi ? (
        <Container>
          <NearByHospital
            pickupLocation={patientAddress}
            nearByHospital={hospitalLists}
            handleAddressSelection={handleSelectHospital}
            selectedHospital={selectedHospital}
            component={component}
            km={value}
          />
        </Container>
      ) : (
        <></>
      )}
      {!component && isAddressSelected && isHospitalSelected && (
        <Container className={style.rebox}>
          <Button
            className={style.button}
            text={isEmergency === "no" ? "Proceed" : "Start Emergency"}
            onClick={handleStartEmergency}
          />
        </Container>
      )}
    </Container>
  );
};
